import { render, staticRenderFns } from "./SelectTypeOfAccount.vue?vue&type=template&id=6b9e551e"
import script from "./SelectTypeOfAccount.vue?vue&type=script&lang=js"
export * from "./SelectTypeOfAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports